namespace accessEnum {
  export enum Access {
    ProductUpdate = "order-product-update",
    AddressUpdate = "address-update",
      PaymentUpdate = "order-payment-update" ,
    DeliveryUpdate = "order-delivery-update",
  }
}
export default accessEnum;
